export default __webpack_public_path__ + "static/media/Users-active.454b1610.svg";